import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import { ApiService } from './api.service';

export interface NotificationTemplateDto {
  id: string | null;
  key: string;
  /** Qachon yuborilishi — admin panelda ko'rsatiladi. */
  description: string;
  /** Shu xabarda ishlatsa bo'ladigan tokenlar, masalan "{biznes}". */
  tokens: string[];
  language: string;
  /** Admin yozgan matn. null — hali yozilmagan, standart ishlatiladi. */
  body: string | null;
  /** Koddagi standart matn — admin nimaga qaytishini bilishi uchun. */
  defaultBody: string;
  isActive: boolean;
  updatedAt: string | null;
}

export interface SaveNotificationTemplateInput {
  key: string;
  language: string;
  /** Bo'sh yuborilsa standart matnga qaytariladi. */
  body: string | null;
  isActive: boolean;
}

@Injectable({ providedIn: 'root' })
export class NotificationTemplatesService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/SuperAdmin/notification-templates`;

  getAll(): Observable<ApiResponse<NotificationTemplateDto[]>> {
    return this.http.get<ApiResponse<NotificationTemplateDto[]>>(this.endpoint);
  }

  save(input: SaveNotificationTemplateInput): Observable<ApiResponse<{ id: string | null }>> {
    return this.http.put<ApiResponse<{ id: string | null }>>(this.endpoint, input);
  }
}
